"use client";

import { useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";

export default function RatePingConfirmationCancellation({ratePingConfirmation, ratePingConfirmationCancellation, onClickHandle}) {
  const [showPopup, setShowPopup] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(null);

  useEffect(() => {
    
     const handleVerify = async () => {
       try {
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_CMS_BASE_URL}/Api/booking/rate-match-approval`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              uniqueId: ratePingConfirmation,
              isApproved: ratePingConfirmationCancellation
            }),
          }
        );
         // if (!response.ok) throw new Error("API failed");

          const data = await response?.json();
          
        if (data?.errorCode === "0") {
            setShowErrorMessage(null);
          setShowPopup(true);
          setShowError(false);
          console.log("rate-match-approval data", data);
        }else{
            setShowErrorMessage(data?.errorMessage);
          setShowPopup(true);
         setShowError(true)
        }
          
       } catch (err) {
        
          setShowPopup(true);
         console.error(err);
         setShowError(true)
       }
     };
    if (ratePingConfirmation) {
      
     handleVerify();
    } 

  }, [ratePingConfirmation]);

  if (!ratePingConfirmation) return null;


  
  return (
    
    <div className="bogo-offer-popup-main fixed inset-0 z-[999999999999] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4 py-5">
      <div className="relative bg-white w-full max-w-lg rounded-3xl shadow-2xl p-8 bogo-offer-popup">

        {/* Close */}
        {showPopup && <button
          onClick={onClickHandle}
          className="absolute z-[99999999] top-4 right-4 text-gray-500 hover:text-black text-xl bogo-close-btn"
        >
          ✕
        </button>}

        {/* Content */}
        <div className="text-center">
          <h4 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3 mt-3 bogo-offer-title">
            Thank You!
          </h4>

          {showError ? (<div className="bogo-inclusions">
            <p>thank you for your response.</p>
          </div>): (<>{ratePingConfirmationCancellation == "D" ? (<p className="text-gray-600 mb-2 px-3">
            Current rate will be shown to the user.
          </p>):(<p className="text-gray-600 mb-2 px-3">
            We will match this rate for the user.
          </p>

          )}</>)}

          {/* Apply */}
          {showErrorMessage && <div className="bogo-inclusions">
            <p>{showErrorMessage}</p>
          </div>}

          {/* Apply */}
          {showPopup && <button
          style={{marginBottom : "5px !important"}}
            onClick={onClickHandle}
            className="mt-6 mb-6 btn btn-primary"

          >
            Close
          </button>}
        </div>
      </div>
    </div>
  );
}
